import React from 'react'
export interface EloBaseIconProps {
  size?: number
  color?: string
  onClick?: (event?: React.MouseEvent<SVGElement>) => void
  viewBox?: string
}
